document.addEventListener("DOMContentLoaded", function() {
  const mobileNavEl = document.querySelector("[data-mobile-nav]");
  const bodyEl = document.querySelector("body");
  const mobileHamburger = document.querySelector("[data-hamburger-menu]");
  const mobileNavClose = document.querySelector("[data-mobile-nav-close]");

  // Nav Mobile menu
  mobileHamburger.addEventListener('click', function(e){
    if (mobileNavEl.classList.contains('open')) {
      mobileNavEl.classList.remove('open');
      bodyEl.classList.remove('no-scroll');
    } else {
      mobileNavEl.classList.add('open');
      bodyEl.classList.add('no-scroll');
    }
  });

  // Nav Mobile menu
  mobileNavClose.addEventListener('click', function(e){
    if (mobileNavEl.classList.contains('open')) {
      mobileNavEl.classList.remove('open');
      bodyEl.classList.remove('no-scroll');
    } else {
      mobileNavEl.classList.add('open');
      bodyEl.classList.add('no-scroll');
    }
  });
})
